import { createStyles, withStyles, WithStyles } from '@domonda/ui/styles';

const styles = createStyles(({ palette, spacing }) => ({
/*
  detections: {
    backgroundColor: '#ffffff',
    padding: spacing(0, 1),
    borderRight: `1px solid #CFDDE2`,
  },
  pages: {
    position: 'relative',
    background: '#F4F7F8',
    padding: '16px 0 0 16px',
  },
  actionBar: {
    position: 'fixed',
    top: '30vh',
    right: '16px',
    padding: '16px 0',
    width: '58px',
    background: '#FFFFFF',
    boxShadow: '1px 2px 4px rgba(0, 0, 0, 0.2)',
    borderRadius: '8px',
    zIndex: '11',
  },
*/
}));

export type Decorate = WithStyles<typeof styles>;

export const decorate = withStyles(styles);
